export function Hero() {
  const handleAssessment = () => {
    window.REACT_APP_NAVIGATE('/property-assessment');
  };

  const handleBookCall = () => {
    window.REACT_APP_NAVIGATE('/book-call');
  };

  const handleCalculator = () => {
    window.REACT_APP_NAVIGATE('/revenue-calculator');
  };

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden w-full">
      <div className="absolute inset-0 bg-gradient-to-br from-[#F0F0F0] via-white to-[#F0F0F0]"></div>
      
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M54.627 0l.83.828-1.415 1.415L51.8 0h2.827zM5.373 0l-.83.828L5.96 2.243 8.2 0H5.374zM48.97 0l3.657 3.657-1.414 1.414L46.143 0h2.828zM11.03 0L7.372 3.657 8.787 5.07 13.857 0H11.03zm32.284 0L49.8 6.485 48.384 7.9l-7.9-7.9h2.83zM16.686 0L10.2 6.485 11.616 7.9l7.9-7.9h-2.83zm20.97 0l9.315 9.314-1.414 1.414L34.828 0h2.83zM22.344 0L13.03 9.314l1.414 1.414L25.172 0h-2.83zM32 0l12.142 12.142-1.414 1.414L30 .828 17.272 13.556 15.858 12.14 28 0zm0 3.657l10.485 10.485-1.414 1.414L32 6.485 22.929 15.556l-1.414-1.414L32 3.657z' fill='%23882629' fill-opacity='1' fill-rule='evenodd'/%3E%3C/svg%3E")`,
        }}></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-6 lg:px-12 py-32 w-full">
        <div className="grid lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-7">
            <div className="text-[#882629] text-sm font-medium mb-6 tracking-wide">
              WE TURN COMPLIANCE INTO CASHFLOW
            </div>
            
            <h1 className="font-['Fraunces'] text-5xl lg:text-6xl font-bold text-[#505A5A] leading-tight mb-6">
              Earn rental income without risking fines, licence loss, or bylaw violations
            </h1>
            
            <p className="text-lg lg:text-xl text-[#505A5A]/70 leading-relaxed mb-10 max-w-xl">
              We help homeowners legally host short stays or furnished medium-term rentals by navigating city rules, strata bylaws, and provincial regulations for you.
            </p>
            
            <div className="flex flex-wrap gap-4 mb-12">
              <button 
                onClick={handleCalculator}
                className="bg-[#882629] text-white px-8 py-4 rounded-full text-base font-medium hover:bg-[#6E1F22] transition-all cursor-pointer whitespace-nowrap flex items-center gap-2 shadow-lg hover:shadow-xl"
              >
                Estimate my rental revenue
                <i className="ri-arrow-right-line"></i>
              </button>
              <button 
                onClick={handleBookCall}
                className="border-2 border-[#882629] text-[#882629] px-8 py-4 rounded-full text-base font-medium hover:bg-[#882629] hover:text-white transition-all cursor-pointer whitespace-nowrap"
              >
                Book a free intro call
              </button>
            </div>

            <div className="flex items-center gap-4 mb-8">
              <div className="flex -space-x-3">
                <div className="w-12 h-12 rounded-full bg-gradient-to-br from-[#882629] to-[#6E1F22] border-2 border-white flex items-center justify-center">
                  <i className="ri-user-line text-white text-lg"></i>
                </div>
                <div className="w-12 h-12 rounded-full bg-gradient-to-br from-[#6E1F22] to-[#505A5A] border-2 border-white flex items-center justify-center">
                  <i className="ri-user-line text-white text-lg"></i>
                </div>
                <div className="w-12 h-12 rounded-full bg-gradient-to-br from-[#505A5A] to-[#3D4444] border-2 border-white flex items-center justify-center">
                  <i className="ri-user-line text-white text-lg"></i>
                </div>
              </div>
              <p className="text-sm text-[#505A5A]/70">
                <strong className="text-[#505A5A]">Trusted by 200+</strong> Vancouver homeowners
              </p>
            </div>

            <div className="space-y-4">
              <div className="bg-white rounded-xl p-5 shadow-md border border-[#F0F0F0]">
                <div className="flex items-start gap-3 mb-3">
                  <div className="flex text-[#882629] text-lg">
                    <i className="ri-star-fill"></i>
                    <i className="ri-star-fill"></i>
                    <i className="ri-star-fill"></i>
                    <i className="ri-star-fill"></i>
                    <i className="ri-star-fill"></i>
                  </div>
                </div>
                <p className="text-[#505A5A] text-sm leading-relaxed mb-3">
                  "They handled all the compliance paperwork and got our STR licence approved in under 3 weeks. We're now earning $3,200/month legally and stress-free."
                </p>
                <p className="text-[#505A5A] font-semibold text-sm">— Sarah Chen, Vancouver West</p>
              </div>

              <div className="bg-white rounded-xl p-5 shadow-md border border-[#F0F0F0]">
                <div className="flex items-start gap-3 mb-3">
                  <div className="flex text-[#882629] text-lg">
                    <i className="ri-star-fill"></i>
                    <i className="ri-star-fill"></i>
                    <i className="ri-star-fill"></i>
                    <i className="ri-star-fill"></i>
                    <i className="ri-star-fill"></i>
                  </div>
                </div>
                <p className="text-[#505A5A] text-sm leading-relaxed mb-3">
                  "I was worried about strata rules, but they reviewed everything and found a compliant path forward. Professional, transparent, and worth every penny."
                </p>
                <p className="text-[#505A5A] font-semibold text-sm">— Michael Rodriguez, North Vancouver</p>
              </div>
            </div>
          </div>

          <div className="lg:col-span-5">
            <div className="relative">
              <div className="rounded-3xl overflow-hidden shadow-2xl">
                <img 
                  src="https://public.readdy.ai/ai/img_res/c506a78be50a4f54e99d274868764d89.jpg" 
                  alt="Bright naturally lit Vancouver rental interior"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              
              <div className="absolute -bottom-6 -left-6 bg-white rounded-2xl shadow-xl px-6 py-4 flex items-center gap-3">
                <div className="w-10 h-10 bg-[#882629] rounded-full flex items-center justify-center">
                  <i className="ri-shield-check-line text-white text-xl"></i>
                </div>
                <div>
                  <div className="text-sm font-semibold text-[#505A5A]">Licensed & Insured</div>
                  <div className="text-xs text-[#505A5A]/60">Fully compliant operations</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
